import { render, staticRenderFns } from "./QuestionFilter.vue?vue&type=template&id=b8138ab6&"
import script from "./QuestionFilter.vue?vue&type=script&lang=js&"
export * from "./QuestionFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports